import { select, takeLatest, all, put } from 'redux-saga/effects';
import { privateCall } from './api.saga';
import { cmsActions } from '../reducers/cms.reducer';
import { posActions } from '../reducers/pos.reducer';
import { ppcActions } from '../reducers/ppc.reducer';
import { modalActions } from '../reducers/modal.reducer';
import { history } from '../store/store';

function* navigation({ payload: { formData = {}, method = 'get' } }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.cms.navigation);
		const { navigation } = yield privateCall({ endpoint, payload: formData, method });

		if (method === 'delete')
			yield put(cmsActions.delNavigation({ navID: formData.navID }));
		else
			yield put(cmsActions.setState({ navigation }));
	} catch (e) {}
}

function* articles({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.articles}${route ? `/${route}` : ''}`);
		const { articles, pages } = yield privateCall({ endpoint, payload: formData, method });

		if (method === 'post') {
			yield put(modalActions.hide());
		}

		yield put(cmsActions.setArticle(articles));

		if (pages)
			yield put(posActions.setPage(pages));
	} catch (e) {}
}

function* tmpSlot({ payload: { formData = {}, method = 'put', route } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.tmpSlot}/${route}`);
		const { navigation } = yield privateCall({ endpoint, payload: formData, method });

		yield put(cmsActions.setState({ navigation }));
	} catch (e) {}
}

function* pageAsset({ payload: { formData = {}, method = 'post', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.pageAsset}${route ? `/${route}` : ''}`);
		const { pages } = yield privateCall({ endpoint, payload: formData, method });

		yield put(posActions.setPage(pages));
	} catch (e) {}
}

function* articleAsset({ payload: { formData = {}, method = 'post', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.articleAsset}${route ? `/${route}` : ''}`);
		const { articles } = yield privateCall({ endpoint, payload: formData, method });

		yield put(cmsActions.setArticle(articles));
	} catch (e) {}
}

function* assets({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.assets}${route ? `/${route}` : ''}`);
		const { assets, articles } = yield privateCall({ endpoint, payload: formData, method });

		if (assets)
			yield put(cmsActions.setAssets(assets));

		if (articles)
			yield put(cmsActions.setArticle(articles));
	} catch (e) {}
}

function* contacts({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.contacts}${route ? `/${route}` : ''}`);
		const { contacts } = yield privateCall({ endpoint, payload: formData, method });

		if (method === 'delete' && !route) {
			history.push('/contacts');
			yield put(cmsActions.delContact({ contactID: formData.contactID }));
		}
		else
			yield put(cmsActions.setContacts(contacts));

	} catch (e) {}
}

function* popups({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.popups}${route ? `/${route}` : ''}`);
		const { popups } = yield privateCall({ endpoint, payload: formData, method });

		if (method === 'post') {
			yield put(modalActions.hide());
		}

		yield put(cmsActions.setPopup(popups));
	} catch (e) {}
}

function* popupAsset({ payload: { formData = {}, method = 'post', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.popupAsset}${route ? `/${route}` : ''}`);
		const { popups } = yield privateCall({ endpoint, payload: formData, method });

		yield put(cmsActions.setPopup(popups));
	} catch (e) {}
}

function* users({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.users}${route ? `/${route}` : ''}`);
		const { users } = yield privateCall({ endpoint, payload: formData, method });

		if (method === 'delete') {
			history.push('/users');
			yield put(cmsActions.delUser({ userID: formData.userID }));
		}
		else
			yield put(cmsActions.setUsers(users));
	} catch (e) {}
}

function* projectIcons({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.projectIcons}${route ? `/${route}` : ''}`);
		const { projectIcons } = yield privateCall({ endpoint, payload: formData, method });

		yield put(cmsActions.setState({ projectIcons }));
	} catch (e) {}
}

function* permissions({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.permissions}${route ? `/${route}` : ''}`);
		const { permissions } = yield privateCall({ endpoint, payload: formData, method });

		yield put(cmsActions.setPermissions(permissions));
	} catch (e) {}
}

function* getDocument({ payload }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.cms.document.getURI);
		const { uri } = yield privateCall({ endpoint, payload, method: 'get' });

		window.open(uri);
	} catch (e) {}
}

function* altTag({ payload }) {
	try {
		const endpoint = yield select(s => s.config.endpoints.pos.altTag);
		const { pages, articles } = yield privateCall({ endpoint, payload, method: 'put' });

		if (pages)
			yield put(posActions.setPage(pages));

		if (articles)
			yield put(cmsActions.setArticle(articles));
	} catch (e) {}
}

function* siteSettings({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.siteSettings}${route ? `/${route}` : ''}`);
		const { siteSettings } = yield privateCall({ endpoint, payload: formData, method });

		if (siteSettings)
			yield put(cmsActions.setSiteSettings(siteSettings));
	} catch (e) {}
}

function* seo({ payload: { formData = {}, method = 'get', route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.seo}${route ? `/${route}` : ''}`);
		const {
			siteSettings,
			ppcPage,
			ppcProductCategory,
			ppcProduct,
			ppcServiceCategory,
			ppcService,
		} = yield privateCall({ endpoint, payload: formData, method });

		if (siteSettings)
			yield put(cmsActions.setSiteSettings(siteSettings));

		if (ppcPage)
			yield put(ppcActions.setPage({ details: ppcPage }));

		if (ppcProduct || ppcProductCategory)
			yield put(ppcActions.setProduct({
				category: ppcProductCategory ? ppcProductCategory : null,
				details: ppcProduct ? ppcProduct : null,
			}));

		if (ppcService || ppcServiceCategory)
			yield put(ppcActions.setService({
				category: ppcServiceCategory ? ppcServiceCategory : null,
				details: ppcService ? ppcService : null,
			}));

	} catch (e) {}
}

function* slot({ payload: { formData = {}, route = null } }) {
	try {
		const endpoint = yield select(s => `${s.config.endpoints.cms.slot}${route ? `/${route}` : ''}`);
		const {
			details,
			index,
			articles,
		} = yield privateCall({ endpoint, payload: formData, method: 'put' });

		switch (route) {

			case 'ppc-product-images':
				yield put(ppcActions.setProduct({ details, index }));
				break;

			case 'pos-article-slideshow':
				yield put(cmsActions.setArticle(articles));
				break;
		}
	} catch (e) {}
}

export default function* cmsSaga() {
	yield all([
		yield takeLatest(cmsActions.articleAsset, articleAsset),
		yield takeLatest(cmsActions.articles, articles),
		yield takeLatest(cmsActions.assets, assets),
		yield takeLatest(cmsActions.contacts, contacts),
		yield takeLatest(cmsActions.navigation, navigation),
		yield takeLatest(cmsActions.pageAsset, pageAsset),
		// yield takeLatest(cmsActions.pages, pages),
		yield takeLatest(cmsActions.popupAsset, popupAsset),
		yield takeLatest(cmsActions.popups, popups),
		yield takeLatest(cmsActions.tmpSlot, tmpSlot),
		yield takeLatest(cmsActions.users, users),
		yield takeLatest(cmsActions.projectIcons, projectIcons),
		yield takeLatest(cmsActions.permissions, permissions),
		yield takeLatest(cmsActions.getDocument, getDocument),
		yield takeLatest(cmsActions.altTag, altTag),
		yield takeLatest(cmsActions.siteSettings, siteSettings),
		yield takeLatest(cmsActions.seo, seo),
		yield takeLatest(cmsActions.slot, slot),
	]);
}
